module.exports = __webpack_public_path__ + "img/91-cbb8dc.png";